module.exports = __webpack_public_path__ + "media/images/icon_baseinfo_home-1760f33ba735ab0524915040a52d0a52.png";